import { IQueryUpdatedAction, QueryActionType } from ".";

/**
 * User initiates a search
 * 
 * @param query
 */
export const QueryUpdatedAction = (query: string): IQueryUpdatedAction => {
    return {
        type: QueryActionType.QUERY_UPDATED,
        query
    };
}